<nav aria-label="Page navigation" *ngIf="totalPages > 0">
  <ul class="flex items-center -space-x-px" 
      [ngClass]="{'h-8 text-sm': size === 'sm', 'h-10 text-base': size === 'md'}">
    <!-- Previous Button -->
    <li>
      <button 
        (click)="onPreviousClick()"
        [disabled]="isFirstPage()"
        class="flex items-center justify-center ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
        [ngClass]="{'px-3 h-8': size === 'sm', 'px-4 h-10': size === 'md'}">
        <span class="sr-only">Previous</span>
        <svg [ngClass]="{'w-2.5 h-2.5': size === 'sm', 'w-3 h-3': size === 'md'}" 
             class="rtl:rotate-180" 
             aria-hidden="true" 
             xmlns="http://www.w3.org/2000/svg" 
             fill="none" 
             viewBox="0 0 6 10">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 1 1 5l4 4"/>
        </svg>
      </button>
    </li>

    <!-- Page Numbers -->
    <li *ngFor="let page of pages">
      <button 
        (click)="onPageClick(page)"
        [attr.aria-current]="page === currentPage ? 'page' : null"
        [ngClass]="{
          'z-10 text-blue-600 border-blue-300 bg-blue-50 hover:bg-blue-100 hover:text-blue-700': page === currentPage,
          'text-gray-500 bg-white border-gray-300 hover:bg-gray-100 hover:text-gray-700': page !== currentPage,
          'px-3 h-8': size === 'sm', 
          'px-4 h-10': size === 'md'
        }"
        class="flex items-center justify-center leading-tight border">
        {{page}}
      </button>
    </li>

    <!-- Next Button -->
    <li>
      <button 
        (click)="onNextClick()"
        [disabled]="isLastPage()"
        class="flex items-center justify-center leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
        [ngClass]="{'px-3 h-8': size === 'sm', 'px-4 h-10': size === 'md'}">
        <span class="sr-only">Next</span>
        <svg [ngClass]="{'w-2.5 h-2.5': size === 'sm', 'w-3 h-3': size === 'md'}" 
             class="rtl:rotate-180" 
             aria-hidden="true" 
             xmlns="http://www.w3.org/2000/svg" 
             fill="none" 
             viewBox="0 0 6 10">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
        </svg>
      </button>
    </li>
  </ul>
</nav>

<!-- Mobile Responsive Version (Optional) -->
<nav aria-label="Page navigation mobile" *ngIf="totalPages > 0" class="md:hidden">
  <div class="flex justify-between items-center">
    <button 
      (click)="onPreviousClick()"
      [disabled]="isFirstPage()"
      class="flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">
      <svg class="w-3.5 h-3.5 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 1 1 5l4 4"/>
      </svg>
      Previous
    </button>
    
    <span class="text-sm text-gray-700">
      Page <span class="font-semibold">{{currentPage}}</span> of <span class="font-semibold">{{totalPages}}</span>
    </span>
    
    <button 
      (click)="onNextClick()"
      [disabled]="isLastPage()"
      class="flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">
      Next
      <svg class="w-3.5 h-3.5 ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
      </svg>
    </button>
  </div>
</nav>